import React from "react";
import axios from "axios";
import Renovation from "./Renovation";
import Error404 from "./Error404";
import Row from "react-bootstrap/Row";
import { Container } from "react-bootstrap";
import {Loading} from "./partials/Global/Loading";
import {CopyRight} from "./partials/Global/CopyRight";
import {FooterBody} from "./partials/Global/FooterBody";
import {Navigation} from "./partials/Global/Navigation";
import {DottedLoading} from "./partials/Global/DottedLoading";
import {ProgressScrollButton} from "./partials/Global/ProgressScrollButton";
import Pagination from "./partials/Global/Pagination";

class Renovations extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            renovationGroup: this.props.match.params.status,
            renovations: {},
            paginate: [],
            isLoading: true
        };

        // Set current page from url or 1
        const query = new URLSearchParams(this.props.location.search);
        this.state.paginate.currentPage = query.get("page") || 1;
    };

    handleGroupChange = (event) =>  {
        let group = event.target.getAttribute("data-value");
        const paginate = {...this.state.paginate};

        // Reset to page 1
        paginate.currentPage = 1;

        this.setState({
            paginate: paginate,
            renovationGroup: group
        });
        this.props.history.push(group);
    };


    async componentDidMount() {
        await this.getRenovations();
    }

    async componentDidUpdate(prevProps, prevState) {
        const query = new URLSearchParams(this.props.history.location.search);
        if (prevState.renovationGroup !== this.state.renovationGroup){
            await this.getRenovations();
        }

        if (this.state.paginate.currentPage !== prevState.paginate.currentPage) {
            query.set("page", this.state.paginate.currentPage);
            this.props.history.push(
                decodeURIComponent(this.props.location.pathname) +
                "?" +
                decodeURIComponent(query.toString())
            );

            await this.getRenovations();
        }
    }

    getRenovations = async () => {
        this.setState({isLoading: true});
        const result = await axios
            .post(
                process.env.REACT_APP_API_URL +
                    process.env.REACT_APP_GET_RENOVATIONS_PATH +
                this.state.paginate.currentPage +
                '/10.json',
                {
                    apiKey: process.env.REACT_APP_API_PUBLIC_TOKEN,
                    status: this.state.renovationGroup,
                }
            );

        const renovations = [];
        result.data.result.data.renovations.forEach(item => {
            renovations.push(item);
        });

        this.setState({
            renovations: renovations,
            paginate: result.data.result.data.paginate,
            isLoading: false
        });
        return result;
    }

    updatePaginate = currentPage => {
        const paginate = {...this.state.paginate};
        paginate.currentPage = currentPage;
        this.setState({paginate});
    };

    render() {
        if (! ['completed', 'under-construction', 'under-design', 'branches', 'all'].includes(this.state.renovationGroup)) return <Error404 />
        return (
            <>
                <Loading/>
                <ProgressScrollButton/>
                <Navigation/>
                <main>
                    <header className="work-header">
                        <Container className="mt-80">
                            <Row>
                                <div className="col-12">
                                    <div className="caption">
                                        <div className="sub-title">
                                            <a href={"/"}><span>خانه</span></a>
                                            <span>&nbsp; / &nbsp;</span>
                                            <span>بازسازی و بهسازی</span>
                                        </div>
                                        <h1>بازسازی و بهسازی</h1>
                                    </div>
                                </div>
                            </Row>
                        </Container>
                    </header>
                    <section className="portfolio pt-70 pb-0">
                        <div className="container-xxl">
                            <Row>
                                <div className="filtering col-12 mb-60 text-center">
                                    <div className="filter">
                                        <span className="text">فیلتر با :</span>
                                        <span onClick={this.handleGroupChange}
                                              data-value='all'
                                              className={this.state.renovationGroup === 'all'? 'active' : ''}>همه</span>
                                        <span onClick={this.handleGroupChange}
                                              data-value='under-construction'
                                              className={this.state.renovationGroup === 'under-construction'? 'active' : ''}>فعال</span>
                                        <span onClick={this.handleGroupChange}
                                              data-value='completed'
                                              className={this.state.renovationGroup === 'completed'? 'active' : ''}>اتمام یافته</span>
                                    </div>
                                </div>
                            </Row>
                            {!this.state.isLoading
                                ? <div className="gallery padding-rl-20">
                                    <Row className="grid max-margin">
                                        {Object.keys(this.state.renovations).map(key => (
                                            <Renovation key={key} data={this.state.renovations[key]} />
                                        ))}
                                    </Row>
                                </div>
                                : <div className='mt-30 mb-80 text-center' style={{marginRight: '49%'}}><DottedLoading/></div>}
                        </div>
                    </section>
                    {!this.state.isLoading && this.state.renovations.length >= 1 &&
                    <section className="main-shop section-padding pt-0 pb-70">
                        <div className="container">
                            <div className="row md-marg">
                                <div className="col-lg-12">
                                    <div className={"shop-products"}>
                                        <Row>
                                            <div className="pagination d-flex justify-content-center mt-30">
                                                <Pagination
                                                    paginate={this.state.paginate}
                                                    updatePaginate={this.updatePaginate}
                                                />
                                            </div>
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>}
                </main>
                <footer className="pt-80 sub-bg">
                    <FooterBody/>
                    <CopyRight/>
                </footer>
            </>
        );
    }
}

export default Renovations;
